import { Room, ScreenSharePresets, VideoPresets } from 'livekit-client';
export function getLiveKitServerHost(livekitServerUrl) {
    try {
        return new URL(livekitServerUrl).host || livekitServerUrl;
    }
    catch {
        return livekitServerUrl;
    }
}
export function createLiveKitRoomOptions(isGroupConsultation = false) {
    return {
        adaptiveStream: true,
        dynacast: true,
        // Wi‑Fi↔LTE / flaky networks: ICE restart then full reconnect, silently.
        disconnectOnPageLeave: true,
        reconnectPolicy: {
            nextRetryDelayInMs: (context) => {
                if (context.retryCount >= 15) {
                    return null;
                }
                return Math.min(300 * 2 ** context.retryCount, 8000);
            },
        },
        audioCaptureDefaults: {
            autoGainControl: true,
            channelCount: 1,
            echoCancellation: true,
            noiseSuppression: true,
        },
        videoCaptureDefaults: isGroupConsultation
            ? {
                resolution: VideoPresets.h540.resolution,
                frameRate: 30,
            }
            : {
                resolution: VideoPresets.h540.resolution,
                frameRate: 24,
            },
        publishDefaults: {
            videoCodec: 'vp8',
            ...(isGroupConsultation
                ? {
                    // Более лёгкие слои с release/2.0.0 — меньше нагрузка на CPU/сеть.
                    simulcast: true,
                    videoSimulcastLayers: [VideoPresets.h360, VideoPresets.h180],
                }
                : {
                    // В 1:1 один слой, а качеством управляет VideoQualityMonitor.
                    simulcast: false,
                    videoEncoding: {
                        maxBitrate: 1200000,
                        maxFramerate: 24,
                    },
                }),
            screenShareEncoding: ScreenSharePresets.h720fps15.encoding,
            degradationPreference: 'maintain-framerate',
            dtx: true,
            red: true,
            stopMicTrackOnMute: false,
        },
    };
}
export function createLiveKitRoom(isGroupConsultation = false) {
    return new Room(createLiveKitRoomOptions(isGroupConsultation));
}
